import { jsx } from 'react/jsx-runtime';
import { E as EGDSLayout } from '../layout/index-chunk.esm.js';
import * as React from 'react';
import { E as EGDSLayoutSpaces, c as EGDSLayoutSizes } from '../types/index-chunk.esm2.js';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import styles from '../styles/uitk-egds-layout-flex.css';
const EgdsSizingLengths = ['0x', '0x__half', '0x__quarter', '1x', '1x__half', '2x', '3x', '3x__half', '4x', '4x__half', '5x', '6x', '7x', '8x', '9x', '10x', '11x', '12x', '13x', '14x', '15x', '16x', '17x', '18x', '24x', '30x', '37x', '38x', '40x', '48x', '70x', '72x', '76x', '88x', '96x', '104x', '112x', '120x', '180x', '312x', '500x'];
const EGDSLayoutFlexDirectionMap = [['row', 'flex-direction-row'], ['row-reverse', 'flex-direction-row-reverse'], ['column', 'flex-direction-column'], ['column-reverse', 'flex-direction-column-reverse']];
const EGDSLayoutFlexDirections = new Map(EGDSLayoutFlexDirectionMap);
const EGDSLayoutFlexWrapMap = [['nowrap', 'flex-wrap-nowrap'], ['wrap', 'flex-wrap-wrap'], ['wrap-reverse', 'flex-wrap-wrap-reverse']];
const EGDSLayoutFlexWraps = new Map(EGDSLayoutFlexWrapMap);
const EGDSLayoutFlexAlignContentMap = [['center', 'align-content-center'], ['end', 'align-content-flex-end'], ['start', 'align-content-flex-start'], ['space-around', 'align-content-space-around'], ['space-between', 'align-content-space-between']];
const EGDSLayoutFlexAlignContents = new Map(EGDSLayoutFlexAlignContentMap);
const EGDSLayoutFlexJustifyContentMap = [['center', 'justify-content-center'], ['end', 'justify-content-flex-end'], ['start', 'justify-content-flex-start'], ['space-around', 'justify-content-space-around'], ['space-between', 'justify-content-space-between']];
const EGDSLayoutFlexJustifyContents = new Map(EGDSLayoutFlexJustifyContentMap);
const EGDSLayoutFlexAlignItemsMap = [['center', 'align-items-center'], ['end', 'align-items-flex-end'], ['start', 'align-items-flex-start'], ['stretch', 'align-items-stretch']];
const EGDSLayoutFlexAlignItems = new Map(EGDSLayoutFlexAlignItemsMap);
const EGDSLayoutFlexItemGrows = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const EGDSLayoutFlexItemShrinks = [0, 1];
const EGDSLayoutFlexItemAlignSelfMap = [['center', 'align-self-center'], ['end', 'align-self-flex-end'], ['start', 'align-self-flex-start'], ['stretch', 'align-self-stretch']];
const EGDSLayoutFlexItemAlignSelfs = new Map(EGDSLayoutFlexItemAlignSelfMap);
const EGDSLayoutFlexBlockSizeMap = [['full_size', 'block-size-full-size']];
const EGDSLayoutFlexBlockSizes = new Map(EGDSLayoutFlexBlockSizeMap);
const getClassNameList$1 = classNames.bind(styles);
const EGDSLayoutFlex = props => {
  const {
    alignContent,
    alignItems,
    blockSize,
    children,
    className,
    direction,
    justifyContent,
    inline,
    space,
    tag,
    domRef,
    wrap,
    dataTestId,
    ...attributes
  } = props;
  const baseClass = 'uitk-layout-flex';
  const wrapperClassNames = getClassNameList$1(baseClass, alignContent && `${baseClass}-${EGDSLayoutFlexAlignContents.get(alignContent)}`, alignItems && `${baseClass}-${EGDSLayoutFlexAlignItems.get(alignItems)}`, blockSize && `${baseClass}-${EGDSLayoutFlexBlockSizes.get(blockSize)}`, direction && `${baseClass}-${EGDSLayoutFlexDirections.get(direction)}`, justifyContent && `${baseClass}-${EGDSLayoutFlexJustifyContents.get(justifyContent)}`, inline && `${baseClass}-inline`, space && `${baseClass}-${EGDSLayoutSpaces.get(space)}`, wrap && `${baseClass}-${EGDSLayoutFlexWraps.get(wrap)}`, className);
  return children ? jsx(EGDSLayout, {
    className: wrapperClassNames,
    tag: tag,
    domRef: domRef,
    ...attributes,
    ...(dataTestId && {
      'data-test-id': dataTestId
    }),
    children: children
  }) : null;
};
EGDSLayoutFlex.displayName = 'EGDSLayoutFlex';
const getClassNameList = classNames.bind(styles);
const EGDSLayoutFlexItem = props => {
  const {
    alignSelf,
    children,
    className,
    maxWidth,
    minWidth,
    grow,
    shrink,
    style
  } = props;
  /**
   * Check string is a valid EgdsSizingLength value
   *
   * @param size {string} - size
   * @returns EgdsSizingLengths.includes(size as EgdsSizingLength)
   */
  const IsEgdsSize = size => EgdsSizingLengths.includes(size);
  const childrenArray = React.Children.toArray(children);
  const firstChild = childrenArray[0];
  if (!firstChild || typeof firstChild !== 'object' || !('props' in firstChild)) {
    return null;
  }
  const firstChildClassName = firstChild.props.className;
  const firstChildStyle = firstChild.props.style;
  const baseClass = 'uitk-layout-flex-item';
  /**
   * Return a valid className for minWidth or maxWidth
   *
   * @param prop {typeof minWidth | typeof maxWidth} - prop
   * @param prefix {"flex-basis" | "max-width"} - className prefix
   * @returns string
   */
  const lengthClassName = (prop, prefix) => prop && typeof prop === 'string' && `${baseClass}-${prefix}-${IsEgdsSize(prop) ? prop : EGDSLayoutSizes.get(prop)}`;
  const wrapperClassNames = getClassNameList(alignSelf && `${baseClass}-${EGDSLayoutFlexItemAlignSelfs.get(alignSelf)}`, baseClass, firstChildClassName, lengthClassName(maxWidth, 'max-width'), lengthClassName(minWidth, 'flex-basis'), typeof grow !== 'undefined' && Number.isInteger(grow) && `${baseClass}-flex-grow-${grow}`, typeof shrink !== 'undefined' && Number.isInteger(shrink) && `${baseClass}-flex-shrink-${shrink}`, className);
  const wrapperStyle = {
    ...firstChildStyle,
    ...style,
    ...(minWidth && typeof minWidth === 'number' && {
      flexBasis: `${minWidth}px`
    }),
    ...(maxWidth && typeof maxWidth === 'number' && {
      maxInlineSize: `${maxWidth}px`
    })
  };
  const decoratedChild = React.cloneElement(firstChild, {
    className: wrapperClassNames,
    ...(Object.keys(wrapperStyle).length && {
      style: wrapperStyle
    })
  });
  return decoratedChild;
};
EGDSLayoutFlexItem.displayName = 'EGDSLayoutFlexItem';
export { EGDSLayoutFlexDirections as E, EGDSLayoutFlexWraps as a, EGDSLayoutFlexAlignContents as b, EGDSLayoutFlexJustifyContents as c, EGDSLayoutFlexAlignItems as d, EGDSLayoutFlexItemGrows as e, EGDSLayoutFlexItemShrinks as f, EGDSLayoutFlexItemAlignSelfs as g, EGDSLayoutFlexBlockSizes as h, EGDSLayoutFlex as i, EGDSLayoutFlexItem as j };